// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3E81u","options":"AnswerScale_options__140mP","selected":"AnswerScale_selected__1qzMX"};